var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 810,
    viewBox: "0 0 835 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.5 100.5C522.602 115.508 590.5 95 653 82c102-14.5 143.134-30.496 175 33 30.867 61.506-57.44 194.146-60.62 264.789C764.398 446.024 833.019 518.825 828 585c-5.513 72.686-28.535 155.22-90.551 189.419-70.844 39.066-146.657-22.353-225.279-25.29-48.506-1.812-95-5.547-141.579 10.922-75.101 26.554-160.186 55.788-237.981 48.411-70.384-6.675-110.412-47.24-125.579-119.696-17.487-83.54 4.395-118.66 25.994-202.599 12.28-47.725 12.065-89.309 9.403-138.133-3.694-67.748-12.163-143.323 8.928-208.377C70.88 79.441 102.1 29.267 159 8c55.241-20.648 110 6 166.5 24.5 40 18.5 106.037 52.705 152 68",
    fill: "#F3E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/Blob1.cd9bcefdfd9085afbd1b70541931b339.svg";
export { ForwardRef as ReactComponent };